const isCompany = function() {
  //console.log(this.form.cardType, this.form.cardType == 'F')

  return this.form.cardType == 'F'
}
const isImienna = function() {
  

  return this.form.card.type == 'imienna'
}

const isInnyAdres = function() {
  

  return this.form.post_address;
}


export { isCompany, isImienna,isInnyAdres }
